import React from 'react';
import { TableLoader } from './common/table-loader';
import { TabsLoader } from './common/tabs-loader';

export const SearchPageLoader = () => {
  return (
    <div>
      <TabsLoader tabsCount={7} />
      <br />
      <TableLoader hideSearchBar hideFilters hideActions />
      <br />
    </div>
  );
};
